import { ContentPage } from '../page-factory/content-page';
import { makarSankrantiPage } from '../pages/page-kumbh-2025.makar-sankranti';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(makarSankrantiPage);

export default function MakarSankrantiPage() {
  return <ContentPage {...makarSankrantiPage} />;
}
